function firstChar(word: string) {
  return (word.match(/[\p{L}\p{N}]/u)?.[0] ?? "").toUpperCase();
}

export function getInitials(name?: string) {
  const words = (name ?? "").trim().split(/\s+/).filter((word) => firstChar(word));
  if (words.length === 0) return "?";
  if (words.length === 1) return firstChar(words[0]);
  return firstChar(words[0]) + firstChar(words[words.length - 1]);
}
